import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import { computed, ref } from 'vue';
import { RouteLocationRaw } from 'vue-router';

export const PromotionPlanType = {
    Promotion: { value: 1, label: 'Promotion' },
    PromotionBooster: { value: 2, label: 'PromotionBooster' }
};

export function useMixins() {
    const selectedItemType = ref(null as number);
    const linkableItems = ref([] as Array<{ type: number; itemId: number; itemName: string }>);
    const linkableItemOption = computed(() =>
        linkableItems.value
            .filter(item => selectedItemType.value && item.type === selectedItemType.value)
            .map(item => ({ value: item.itemId, label: item.itemName }))
    );

    const fetchLinkableItems = useCrudActions().executeAction({
        request: promotionService.plan.getLinkableItems,
        onSuccess: ({ data }) => void (linkableItems.value = data),
        onError: () => void (linkableItems.value = [])
    });

    const getItemName = (id: number, type: number) =>
        linkableItems.value.find(item => item.itemId === id && item.type === type)?.itemName;

    const getItemLink = (id: number, type: number): RouteLocationRaw => {
        if (!id || !type) return {};
        switch (type) {
            case PromotionPlanType.Promotion.value:
                return { name: ROUTE_NAME_PROMOTION.ITEM.DETAIL, params: { id: id } };
            case PromotionPlanType.PromotionBooster.value:
                return { name: ROUTE_NAME_PROMOTION.BOOSTER.DETAIL, params: { id: id } };
            default:
                return {};
        }
    };

    return { selectedItemType, linkableItemOption, linkableItems, fetchLinkableItems, getItemName, getItemLink };
}

export const Options = {
    Status: [
        { value: 0, label: 'None', background: 'secondary' },
        { value: 1, label: 'Enabled', background: 'info' },
        { value: 2, label: 'Publish', background: 'success' },
        { value: 3, label: 'Unpublish', background: 'warning' },
        { value: 4, label: 'Disabled', background: 'warning' }
    ],

    Type: Object.entries(PromotionPlanType).map(([, data]) => data)
};
